import { AdminEventModel, AdminEventsList } from 'types/admin/trackmanEventsAdmin';

import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';

export class TrackmanEventsEditorService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getEvents = async () => {
    const response = await this.axiosInstance.get<Result<AdminEventsList>>(`/api/admin/trackman-events`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while getting the events list.');
  };

  getEvent = async (id: string) => {
    const response = await this.axiosInstance.get<Result<AdminEventModel>>(`/api/admin/trackman-events/${id}`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while getting this event.');
  };

  deleteEvent = async (id: string) => {
    const response = await this.axiosInstance.delete(`/api/admin/trackman-events/${id}`);

    if (response.status !== 200 || response.data !== '') throw Error('There was an internal error while deleting this event.');
  };

  saveNewEvent = async (data: AdminEventModel) => {
    const response = await this.axiosInstance.post<Result<AdminEventModel>>(
      `/api/admin/trackman-events`,
      {
        tmEvent: data,
        image: data.imageData?.data,
      },
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }

    throw Error('There was an internal error while saving this event.');
  };

  saveExistingEvent = async (data: AdminEventModel) => {
    const response = await this.axiosInstance.put<Result<AdminEventModel>>(
      `/api/admin/trackman-events`,
      {
        tmEvent: data,
        image: data.imageData?.data,
      },
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    if (response.status !== 200) throw Error('There was an internal error while saving this event.');
  };
}

export default TrackmanEventsEditorService;
